import React, { useEffect, useRef, useState } from 'react';
import { mediaUrl } from '../../api/client';
import { IconChevronLeft, IconChevronRight, IconClose } from '../common/Icons';

// Main image + thumbnail strip (vertical on desktop, horizontal on mobile) with a lightbox – like the reference PDP.
export default function Gallery({ images = [], activeIndex = 0, onChange, title = '' }) {
  const [index, setIndex] = useState(activeIndex);
  const [zoom, setZoom] = useState(false);
  const stripRef = useRef(null);
  const touch = useRef(null);

  useEffect(() => setIndex(activeIndex), [activeIndex]);
  useEffect(() => {
    if (onChange) onChange(index);
    const el = stripRef.current?.children?.[index];
    if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }, [index, onChange]);

  if (!images.length) return <div className="sf-image" style={{ '--aspect-ratio': 1 }}><div className="eg-img-placeholder" /></div>;
  const go = (d) => setIndex((i) => (i + d + images.length) % images.length);
  const onTouchStart = (e) => { touch.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touch.current == null) return;
    const dx = e.changedTouches[0].clientX - touch.current;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    touch.current = null;
  };

  return (
    <div className="apb_product_detail_swiper apb_product_detail_img_container_left eg-gallery">
      <div className="eg-gallery-main" onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
        <img src={mediaUrl(images[index].url)} alt={images[index].alt || title} className="apb_product_detail_swiper_img" onClick={() => setZoom(true)} />
        {images.length > 1 && (
          <>
            <button type="button" className="eg-gallery-nav eg-gallery-prev" onClick={() => go(-1)} aria-label="Previous image"><IconChevronLeft width={18} height={18} /></button>
            <button type="button" className="eg-gallery-nav eg-gallery-next" onClick={() => go(1)} aria-label="Next image"><IconChevronRight width={18} height={18} /></button>
            <div className="eg-gallery-count">{index + 1} / {images.length}</div>
          </>
        )}
      </div>
      {images.length > 1 && (
        <div className="eg-gallery-thumbs" ref={stripRef}>
          {images.map((im, i) => (
            <button type="button" key={i} className={`eg-gallery-thumb ${i === index ? 'active' : ''}`} onClick={() => setIndex(i)} aria-label={`Image ${i + 1}`}>
              <img src={mediaUrl(im.url)} alt={im.alt || `${title} ${i + 1}`} loading="lazy" />
            </button>
          ))}
        </div>
      )}
      {zoom && (
        <div className="eg-lightbox" onClick={() => setZoom(false)}>
          <button type="button" className="eg-lightbox-close" aria-label="Close"><IconClose width={22} height={22} /></button>
          <button type="button" className="eg-gallery-nav eg-gallery-prev" onClick={(e) => { e.stopPropagation(); go(-1); }} aria-label="Previous"><IconChevronLeft width={22} height={22} /></button>
          <img src={mediaUrl(images[index].url)} alt={images[index].alt || title} onClick={(e) => e.stopPropagation()} />
          <button type="button" className="eg-gallery-nav eg-gallery-next" onClick={(e) => { e.stopPropagation(); go(1); }} aria-label="Next"><IconChevronRight width={22} height={22} /></button>
        </div>
      )}
    </div>
  );
}
